<template>
    <div id="secure">

        <NewTopMenu />
        <b-notification type="is-success" aria-close-label="Close notification" class="notification-tutorial">
            <center><a v-on:click="goExternalPage(2)">Purchase High Quality QR Tag from us here</a></center>
        </b-notification>
        <div class="container">

            <div class="columns">
                <div class="column is-12">
                    <b>1. Choose design</b>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <v-select :options="listQrType" label="title" class="typeDropdown" key="id" v-model="qrType">
                        <template slot="option" slot-scope="option">
                            <img :src="option.thumb" class="typeImage" />
                            <div class="badgeTitle">{{ option.title }}</div>
                        </template>
                    </v-select>
                </div>
                <!-- <div class="column is-2"><img src="@/assets/img/select_qr_icon_01.png" /></div>
            <div class="column is-2"><img src="@/assets/img/select_qr_icon_02.png" /></div>
            <div class="column is-2"><img src="@/assets/img/select_qr_icon_03.png" /></div>
            <div class="column is-2"><img src="@/assets/img/select_qr_icon_04.png" /></div>
            <div class="column is-2"><img src="@/assets/img/select_qr_icon_05.png" /></div> -->
            </div>
            <!-- <div class="columns">
            <div class="column is-2"><b-radio v-model="qrType" native-value="1">QR Sticker (2.5cm)</b-radio></div>
            <div class="column is-2"><b-radio v-model="qrType" native-value="2">QR Sticker (3.5cm)</b-radio></div>
            <div class="column is-2"><b-radio v-model="qrType" native-value="3">Full QR Tag</b-radio></div>
            <div class="column is-3"><b-radio v-model="qrType" native-value="4">QR Card (1 tag per page)</b-radio></div>
            <div class="column is-2"><b-radio v-model="qrType" native-value="5">Excel</b-radio></div>
        </div> -->
            <div class="columns" v-show="qrType.id == 4">
                <div class="column" style="margin-top: 5px;">
                    <b-checkbox v-model="qrCardOptions" native-value="1">
                        Include class/department name
                    </b-checkbox>
                    <b-checkbox v-model="qrCardOptions" native-value="2">
                        Tick this ONLY if the school logo is wide
                    </b-checkbox>
                </div>
                <div class="column">
                    <v-select :options="listQrBg" label="title" class="badgeDropdown" key="fileName" v-model="qr_bg">
                        <template slot="option" slot-scope="option">
                            <img :src="option.thumb" class="badgeImage" />
                            <div class="badgeTitle">{{ option.title }}</div>
                        </template>
                    </v-select>
                </div>
            </div>

            <div class="columns">
                <div class="column is-12">
                    <b>2. Print by class/department or selected users</b>
                </div>
            </div>
            <div class="columns">
                <div class="column is-12">
                    <b-radio v-model="category" native-value="1">By Class/Department</b-radio>
                    <b-radio v-model="category" native-value="2">Selected Users</b-radio>
                </div>
            </div>

            <div class="columns">
                <div class="column is-12">
                    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false">
                    </loading>
                    <b-select id="kelasID" name="kelasID" v-model="kelasID" v-show="category == 1">
                        <option selected value="-1">Select Class/Department</option>
                        <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{
                kelas.name }}
                        </option>
                    </b-select>
                    <loading :active.sync="isLoading1" :can-cancel="false" :is-full-page="false">
                    </loading>
                    <multiselect v-model="selectedStudents" :options="studentList" :close-on-select="false"
                        :multiple="true" :hide-selected="true" label="name" track-by="name"
                        placeholder="Select students/users to print QR" v-show="category == 2"></multiselect>
                </div>
            </div>

            <div class="columns">
                <div class="column is-6">
                    <loading :active.sync="isLoading2" :can-cancel="false" :is-full-page="false">
                    </loading>
                    <b-button type="is-link" size="button is-medium is-fullwidth" v-on:click="printQR()">Print
                        QR</b-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "ManageQR",
    components: {
        NewTopMenu,
        Loading,
        Multiselect
    },
    data() {
        return {
            schoolID: "",
            schoolPlan: 1,
            kelasID: "-1",
            qrType: 0,
            qrCardOptions: [],

            listQrType: [],
            qrType: {
                id: 1,
                title: "QR Sticker (2.5cm)",
                fileName: "01.png",
                thumb: "http://adminv1.studentqr.com/qrTypes/01.png"
            },
            listQrBg: [],
            qr_bg: {
                id: 1,
                title: "Background 1",
                fileName: "01.jpg",
                thumb: "http://adminv1.studentqr.com/qr_bg/01.jpg"
            },

            category: 1,
            kelasList: [],
            studentList: [],
            selectedStudents: [],
            studentList: [{
                _id: '',
                name: ''
            }],
            isLoading: false,
            isLoading1: false,
            isLoading2: false
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        this.getQRTypes()
        this.getBackgroundQRImages()
        this.getClassList()
        this.getStudentList()
        this.schoolPlan = localStorage.getItem('plan')
    },
    mounted() {
    },
    methods: {
        printQR() {
            console.log("entering printQR with qrType")
            console.log(this.qrType)
            if (this.qrType == 0) {
                Toast.open({
                    message: "Please select the QR type you want to print",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
            } else {
                if (this.category == 1) {
                    if (this.kelasID == "-1") {
                        Toast.open({
                            message: "Please select the class/department you want to print it's QR",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        return false;
                    }
                } else if (this.category == 2) {
                    if (this.selectedStudents.length < 1) {
                        Toast.open({
                            message: "Please select the students/users you want to print it's QR",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        return false;
                    }
                }
                // if (this.qrType.id == 4){
                //     if (this.schoolPlan != 1){
                //         this.$swal({
                //             title: "Please Choose",
                //             text: "Upgrade to Unlimited Behavior Plan to download beautiful QR tag or purchase the card from us.",
                //             showDenyButton: true,
                //             showCancelButton: true,
                //             confirmButtonText: 'Upgrade Plan',
                //             denyButtonText: 'Purchase QR Card',
                //             showCloseButton: true
                //         }).then((result) => {
                //             if (result.isConfirmed){
                //                 this.goExternalPage(1)
                //             }else if (result.isDenied){
                //                 this.goExternalPage(2)
                //             }
                //         });                        
                //         return false;
                //     }
                // }
                this.downloadQRTags(this.qrType.id, this.category)
            }
        },
        downloadQRTags(printType, category) {
            let self = this;
            self.isLoading2 = true;
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/qrTagV2/print', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: category,
                kelasID: self.kelasID,
                selectedStudents: self.selectedStudents,
                printType: printType,
                printOptions: self.qrCardOptions,
                background: self.qr_bg
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (printType == 5) {
                        link.setAttribute('download', 'tags_students.xlsx'); //or any other extension
                    } else {
                        link.setAttribute('download', 'tags_students.pdf'); //or any other extension
                    }
                    document.body.appendChild(link);
                    link.click();
                    self.isLoading2 = false;
                })
                .catch(e => {
                    console.log(e.response)
                    self.isLoading2 = false
                    if (e.response.status === 401) {
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })
        },
        getQRTypes() {
            console.log("entering getQRTypes")
            let self = this;
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/qrTagV2/types/list', {
            })
                .then(response => {
                    // JSON responses are automatically parsed
                    self.listQrType = response.data
                    for (var i = 0; i < self.listQrType.length; i++) {
                        self.listQrType[i].thumb = "http://adminv1.studentqr.com/qrTypes/" + self.listQrType[i].fileName
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getBackgroundQRImages() {
            console.log("entering getBackgroundQRImages")
            let self = this;
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/qrTagV2/backgroundImages/list', {
            })
                .then(response => {
                    // JSON responses are automatically parsed
                    self.listQrBg = response.data
                    for (var i = 0; i < self.listQrBg.length; i++) {
                        self.listQrBg[i].thumb = "https://adminv1.studentqr.com/qr_bg/" + self.listQrBg[i].fileName
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getClassList() {
            let self = this
            self.isLoading0 = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
                .then(response => {
                    self.kelasList = response.data.kelasList
                    self.isLoading = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading = false
                })
        },
        getStudentList() {
            let self = this;
            self.isLoading1 = true;
            axios.defaults.responseType = 'json'
            axios.post('https://adminv2.studentqr.com/api/students/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: "school",
                categoryID: "-"
            })
                .then(response => {
                    self.studentList = []
                    for (var i = 0; i < response.data.length; i++) {
                        var obj = {};
                        obj["_id"] = response.data[i]._id;
                        obj["name"] = response.data[i].firstName + " " + response.data[i].lastName + " (" + response.data[i].kelasID.level + " " + response.data[i].kelasID.name + ")";
                        self.studentList.push(obj);
                    }
                    self.isLoading1 = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false
                })
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
        goExternalPage(where) {
            var url = "https://upgradeplan.wasap.my";
            if (where == 2) {
                url = "https://purchaseQRcard.wasap.my";
            }
            window.open(url, '_blank');
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.container {
    color: #000;
}

.bottom-border {
    border-bottom: 1px solid #CCC
}

.container {
    padding: 10px;
}

.text-center {
    text-align: center;
}

.typeDropdown {
    width: 500px;
}

.typeImage {
    width: 250px;
}

.badgeDropdown {
    width: 300px;
}

.badgeImage {
    width: 50px;
}

.badgeTitle {
    padding-top: 10px !important;
    float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/ManageQR.vue